const getters = {
  getActualListPage: (state) => {
    return state.actualListPage
  },
  getSelectedResource: (state) => {
    return state.selectedResource
  },
  getSelectedResourceSecond: (state) => {
    return state.selectedResourceSecondLevel
  },
  getSelectedResourceID: (state) => {
    if (state.selectedResource !== null) {
      return state.selectedResource
    } else {
      return { objectID: null }
    }
  },
  getCheckedOnPage: (state) => (page) => {
    return state.checkedOnPage[page]
  },
  getCheckedOnPageCount: (state) => (page) => {
    if (state.checkedOnPage[page] === undefined) {
      return null
    } else {
      return Object.keys(state.checkedOnPage[page]).length
    }
  },
  isResourceSelected: (state) => (resourceID, isSecondLevel = false) => {
    if (isSecondLevel) {
      return state.selectedResourceSecondLevel !== null && state.selectedResourceSecondLevel.id === resourceID
    } else {
      return state.selectedResource !== null && state.selectedResource.id === resourceID
    }
  },
  isResourceChecked: (state) => (data) => {
    return (
      state.checkedOnPage[data.page] !== undefined &&
      state.checkedOnPage[data.page][data.resourceID] !== undefined
    )
  },
  getContentLastUrl: (state) => {
    return state.lastUrl
  },
  getResourceOverviewList: (state) => state.resourceOverviewList !== null ? state.resourceOverviewList : [],
  getSecondResourceOverviewList: (state) => state.secondResourceOverviewList !== null ? state.secondResourceOverviewList : [],
  getTotalNumberOverviewList: (state) => state.totalNumberOverviewList,
  getIsFetchingList: (state) => state.isFetchingList
}
export default getters
